import { DialogModal } from "./DialogModal";
import type { ModalProps } from "./types";

/**
 * Modal component that adapts to platform.
 * On small screens, becomes full-screen. On large screens, shows as centered dialog.
 *
 * @example
 * <Modal
 *   open={open}
 *   onOpenChange={setOpen}
 *   headerProps={{ title: "Settings", variant: "titleSubtitle", subtitle: "Customize" }}
 *   footerProps={{ primaryButtonProps: { children: "Save" } }}
 * >
 *   <Text>Content</Text>
 * </Modal>
 */
export const Modal = ({
  open,
  onOpenChange,
  children,
  headerProps,
  footerProps,
  size = "medium",
  scrollable = true,
  animateHeight = true,
  maxHeight,
  fillHeight
}: ModalProps) => {
  return <DialogModal open={open} onOpenChange={onOpenChange} size={size} headerProps={headerProps} footerProps={footerProps} scrollable={scrollable} animateHeight={animateHeight} maxHeight={maxHeight} fillHeight={fillHeight} data-sentry-element="DialogModal" data-sentry-component="Modal" data-sentry-source-file="Modal.tsx">
      {children}
    </DialogModal>;
};